<div class="ipm-producer-join-popup" [class.error-message]="shakeAnimation.showErrorMessage === true">
    <div class="ipm-close-icon" (click)="closeByDeviceType()">
        <i class="pi pi-times"></i>
    </div>
    <h1 class="text-center ipm-model-heading">Just few more notes 🎶</h1>
    <hr class="border-line">
    <div class="ipm-set-max-height">
        <div class="error-message-data" *ngIf="errorMessage">
            {{errorMessage}}
        </div>
        <form class="custom-form" [formGroup]="producerForm">
            <div class="row">
                <div class="col-md-6 ps-0 pe-0 pe-lg-3 pe-md-3">
                    <div class="form-group custom-form-group">
                        <input type="text" class="form-control" placeholder="First Name" formControlName='firstName'
                            name="fname" required>
                            <div class="ipm-error-icon" *ngIf="producerForm.controls['firstName'].invalid && producerForm.controls['firstName'].touched">
                                <img priority src="https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                            </div>
                            <div class="help-block error-message"
                                *ngIf="producerForm.controls['firstName'].invalid && producerForm.controls['firstName'].touched">
                                <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                {{formService.getErrorMessage(producerForm.controls['firstName'])}}
                            </div>
                    </div>
                </div>
                <div class="col-md-6 pe-0 ps-0 ps-lg-3 ps-md-3">
                    <div class="form-group custom-form-group">
                        <input type="text" class="form-control" placeholder="Last Name" formControlName='lastName' name="lname"
                            required>
                        <div class="ipm-error-icon" *ngIf="producerForm.controls['lastName'].invalid && producerForm.controls['lastName'].touched">
                            <img priority src="https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                        </div>
                        <div class="help-block error-message"
                            *ngIf="producerForm.controls['lastName'].invalid && producerForm.controls['lastName'].touched">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                            {{formService.getErrorMessage(producerForm.controls['lastName'])}}
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group custom-form-group">
                <input type="text" class="form-control" placeholder="Email Id" name="email" formControlName="email" required>
                <div class="ipm-error-icon" *ngIf="producerForm.controls['email'].invalid && producerForm.controls['email'].touched">
                    <img priority src="/https://ip-dev.s3.ap-south-1.amazonaws.comassets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                </div>
                <div class="help-block error-message"
                    *ngIf="producerForm.controls['email'].invalid && producerForm.controls['email'].touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    {{formService.getErrorMessage(producerForm.controls['email'])}}
                </div>
            </div>
            <div class="form-group custom-form-group">
                <input type="text" class="form-control" placeholder="Work Link" formControlName="workLink" name="workLink"
                    required>
                    <div class="ipm-error-icon" *ngIf="producerForm.controls['workLink'].invalid && producerForm.controls['workLink'].touched">
                        <img priority src="https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                <div class="help-block error-message"
                    *ngIf="producerForm.controls['workLink'].invalid && producerForm.controls['workLink'].touched ">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true">
                    </i>
                    {{formService.getLinkPatternMessage(producerForm.controls['workLink'])}}
                </div>
            </div>
            <div class="form-group custom-form-group">
                <input type="text" class="form-control" placeholder="Social Link*" formControlName="socialLink"
                    name="socialLink" required>
                    <div class="ipm-error-icon" *ngIf="producerForm.controls['socialLink'].invalid && producerForm.controls['socialLink'].touched">
                        <img priority src="https://ip-dev.s3.ap-south-1.amazonaws.com/assets/imgs/sub-menu/error-icon.svg" alt="error-icon">
                    </div>
                <div class="help-block error-message"
                    *ngIf="producerForm.controls['socialLink'].invalid && producerForm.controls['socialLink'].touched ">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true">
                    </i>
                    {{formService.getLinkPatternMessage(producerForm.controls['socialLink'])}}
                </div>
            </div>
            <div class="checkout-flow"
                [class.error-show]="producerForm.controls['isAcceptTermCondition'] && producerForm.controls['isAcceptTermCondition'].invalid && producerForm.controls['isAcceptTermCondition'].touched">
                <mat-checkbox formControlName="isAcceptTermCondition" required>
                    I hereby state that I have read and agree to the terms and conditions mentioned in the <a
                        class="click-anchor-tag ipm-show-underline" (click)="$event.stopPropagation();openSellerPop()" >Seller Artist Agreement</a>.
                </mat-checkbox>
                <div class="help-block error-message my-1"
                    *ngIf="producerForm.controls['isAcceptTermCondition'] && producerForm.controls['isAcceptTermCondition'].invalid && producerForm.controls['isAcceptTermCondition'].touched">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                    Please acknowledge the term of use.
                </div>
            </div>
            <div class="ipm-actions">
                <button mat-flat-button color="primary" class="primary-button ipm-submit-btn" type="submit"
                    (click)='producerForm.invalid ? producerForm.markAllAsTouched() : registerProducer()'>
                    Submit & Agree
                </button>
            </div>
        </form>

    </div>
</div>

<ng-template #sellerDetails let-data>
    <ipm-seller-agreement></ipm-seller-agreement>
</ng-template>
